import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Resetoi scroll-position sivun yläreunaan kun reitti vaihtuu. SPA-
 * navigaatiossa selain ei tee tätä automaattisesti — käyttäjä jäisi
 * pohjalle scroll-asentoon edellisestä sivusta.
 *
 * Poikkeus: jos location.state sisältää `palauttavaRivi`, näkymä haluaa
 * itse vierittää tietyn elementin näkyviin (esim. TukipyyntoLista palaten
 * tukipyyntönäkymästä) — älä ylikirjoita sitä scrollTop(0):lla.
 */
export default function ScrollToTop() {
  const { pathname, state } = useLocation()
  useEffect(() => {
    const palauttavaRivi = (state as { palauttavaRivi?: string } | null)
      ?.palauttavaRivi
    if (palauttavaRivi) return
    window.scrollTo(0, 0)
  }, [pathname, state])
  return null
}
